export default __webpack_public_path__ + "static/media/roadsideAssistanceCover.47cbbdea.svg";